import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useBellaPush from '../../hooks/useBellaHistoryPush';
import { hideOverlay, showOverlay } from '../../redux/overlays/actions';
import useRouter from '../../hooks/useRouter';
import usePrevious from '../../hooks/usePrevious';
import { OverlayId } from './types';

export const OVERLAY_QUERY_PARAM = 'overlay';

export const useOverlayUrlService = () => {
    const push = useBellaPush();
    const {
        location: { state, pathname, search },
        history,
    } = useRouter();

    const currentOverlayId = typeof state === 'object' ? state?.[OVERLAY_QUERY_PARAM] || '' : '';

    const hasAnActiveOverlay = !!currentOverlayId;

    const pushOverlay = (overlayId: OverlayId) => {
        if (currentOverlayId !== overlayId) {
            push(`${pathname}${search}`, false, { [OVERLAY_QUERY_PARAM]: overlayId });
        }
    };

    const pullOffOverlay = () => {
        if (hasAnActiveOverlay) {
            history.goBack();
        }
    };

    const isActiveOverlay = (overlayId: OverlayId) => overlayId === currentOverlayId;

    return { pushOverlay, pullOffOverlay, hasAnActiveOverlay, isActiveOverlay };
};

const useOverlayStateFromUrl = () => {
    const dispatch = useDispatch();
    const {
        location: { state },
    } = useRouter();

    const overlayId = typeof state === 'object' ? state?.[OVERLAY_QUERY_PARAM] || '' : '';
    const previousOverlayId = usePrevious(overlayId);

    useEffect(() => {
        if (overlayId) {
            dispatch(showOverlay(overlayId));
        } else if (previousOverlayId) {
            dispatch(hideOverlay(previousOverlayId));
        }
    }, [dispatch, overlayId, previousOverlayId]);
};

export default useOverlayStateFromUrl;
